module.exports = {
    createANewPost: {
        en: "Create a new post",
        fi: "Luo ilmoitus"
    },
    userInfo: {
        en: "User info",
        fi: "käyttäjätiedot"
    },
    name: {
        en: "Name",
        fi: "Nimi"
    },
    namePlaceholder: {
        en: "User's or Store's name",
        fi: "Myyjän nimi"
    },
    nameToolTip: {
        en: "Name is required",
        fi: "Nimi on pakollinen"
    },
    email: {
        en: "Email",
        fi: "Sähköposti"
    },
    emailPlaceholder: {
        en: "Email address",
        fi: "Sähköpostiosoite"
    },
    emailToolTip: {
        en: "Email is required",
        fi: "Sähköposti on pakollinen"
    },
    phone: {
        en: "Phone",
        fi: "Puhelin"
    },
    phonePlaceholder: {
        en: "Phone number",
        fi: "Puhelinnumrto"
    },
    phoneToolTip: {
        en: "Phone is required",
        fi: "Puhelinnumero on pakollinen"
    },
    selectARole: {
        en: "Select a role",
        fi: "Valitse rooli"
    },
    individual: {
        en: "Individual",
        fi: "Yksilö"
    },
    store: {
        en: "Store",
        fi: "Yritys"
    },
    selectARoleToolTip: {
        en: "Role is required",
        fi: "Rooli on pakollinen"
    },
    uploadImages: {
        en: "Upload images",
        fi: "Lisää kuvia tietokoneelta"
    },
    uploadImagesToolTip: {
        en: "At least one image is required",
        fi: "Vähintään yksi kuva on pakollinen"
    },
    uploadVideos: {
        en: "Upload videos",
        fi: "Lisää videoita tietokoneelta"
    },
    uploadVideosToolTip: {
        en: "At least one video is required",
        fi: "Vähintään yksi video on pakollinen"
    },
    basicInfo: {
        en: "Basic info",
        fi: "Perustiedot"
    },
    title: {
        en: "Title",
        fi: "Otsikko"
    },
    titlePlaceholder: {
        en: "Title here",
        fi: "Otsikko tässä"
    },
    titleToolTip: {
        en: "Title is required",
        fi: "Otsikko on pakollinen"
    },
    description: {
        en: "Description",
        fi: "Ilmoitusteksti"
    },
    descriptionPlaceholder: {
        en: "Description here",
        fi: "Ilmoitusteksti tässä"
    },
    descriptionToolTip: {
        en: "Description is optional",
        fi: "Ilmoitusteksti on valinnainen"
    },
    price: {
        en: "Price in €",
        fi: "Hinta €"
    },
    pricePlaceholder: {
        en: "Price in € here",
        fi: "Hinta € tässä"
    },
    priceToolTip: {
        en: "Price is required",
        fi: "Hinta on pakollinen"
    },
    selectAType: {
        en: "Select a type",
        fi: "Valitse tyyppi"
    },
    selectATypeToolTip: {
        en: "Type is required",
        fi: "Tyyppi on pakollinen"
    },
    selectASubType: {
        en: "Select a sub type",
        fi: "Valitse alityyppi"
    },
    selectASubTypeToolTip: {
        en: "Sub type is required",
        fi: "Alityyppi on pakollinen"
    },
    selectAMaker: {
        en: "Select a maker",
        fi: "Valitse valmistaja"
    },
    selectAMakerToolTip: {
        en: "Maker is required",
        fi: "Valmistaja on pakollinen"
    },
    otherMakerName: {
        en: "Other maker name",
        fi: "Toinen valmistaja"
    },
    otherMakerNamePlaceholder: {
        en: "Maker name",
        fi: "Valmistajan nimi"
    },
    otherMakerNameToolTip: {
        en: "Other maker name is required",
        fi: "Toinen valmistaja on pakollinen"
    },
    selectACondition: {
        en: "Select a condition",
        fi: "Valitse kuntotaso"
    },
    selectAConditionToolTip: {
        en: "Condition is required",
        fi: "Kuntotaso on pakollinen"
    },
    locationInfo: {
        en: "Location info",
        fi: "Sijainti"
    },
    selectAProvince: {
        en: "Selected Province",
        fi: "Valitse maakunta"
    },
    selectAProvinceToolTip: {
        en: "Province is required",
        fi: "Maakunta on pakollinen"
    },
    selectACity: {
        en: "Select a city",
        fi: "Valitse kaupunki"
    },
    selectACityToolTip: {
        en: "City is required",
        fi: "Kaupunki on pakollinen"
    },
    moreInfo: {
        en: "More info",
        fi: "Lisätietoa"
    },
    selectAFrameSize: {
        en: "Select a frame size",
        fi: "Valitse rungon koko"
    },
    selectAFrameSizeToolTip: {
        en: "Frame size in inches is optional",
        fi: "Rungon tuumakoko on valinnainen"
    },
    selectAGear: {
        en: "Select a gear",
        fi: "Valitse vaihteisto"
    },
    selectAGearToolTip: {
        en: "Amount of gears is optional",
        fi: "Vaihteiden lukumäärä on valinnainen"
    },
    selectATyreType: {
        en: "Select a tyre type",
        fi: "Valitse rengastyyppi"
    },
    selectATyreTypeToolTip: {
        en: "Tyre type is optional",
        fi: "Rengastyyppi on valinnainen"
    },
    selectAMaterial: {
        en: "Select a material",
        fi: "Valitse materiaali"
    },
    selectAMaterialToolTip: {
        en: "Material used is optional",
        fi: "Materiaali on valinnainen"
    },
    selectABreakType: {
        en: "Select a break type",
        fi: "Valitse jarrut"
    },
    selectABreakTypeToolTip: {
        en: "Break type is optional",
        fi: "Jarrutyyppi on valinnainen"
    },
    selectASuspensionType: {
        en: "Select a suspension type",
        fi: "Valitse jousitus"
    },
    selectASuspensionTypeToolTip: {
        en: "Suspension type is optional",
        fi: "Jousituksen tyyppi on valinnainen"
    },
    selectAGender: {
        en: "Select a gender",
        fi: "Valitse sukupuoli"
    },
    selectAGenderToolTip: {
        en: "Gender is optional",
        fi: "Rungon sukupuoli on valinnainen"
    },
    selectANumOfWheels: {
        en: "Select a number of wheels",
        fi: "Valitse renkaiden lukumäärä"
    },
    selectANumOfWheelsToolTip: {
        en: "Number of wheels is optional",
        fi: "Renkaiden lukumäärä on valinnainen"
    },
    selectAWheelSize: {
        en: "Select a wheel size",
        fi: "Valitse rengaskoko"
    },
    selectAWheelSizeToolTip: {
        en: "Wheel size is optional",
        fi: "Renkaiden koko on valinnainen"
    },
    selectAMudGuardType: {
        en: "Select a mud guard type",
        fi: "Valitse lokasuoja"
    },
    selectAMudGuardTypeToolTip: {
        en: "Mud guard type is optional",
        fi: "Lokasuojan tyyppi on valinnainen"
    },
    selectARackType: {
        en: "Select a rack type",
        fi: "Valitse tarakka"
    },
    selectARackTypeToolTip: {
        en: "Rack type is optional",
        fi: "Tarakan tyyppi on valinnainen"
    },
    selectABasketType: {
        en: "Select a basket type",
        fi: "Valitse kori"
    },
    selectABasketTypeToolTip: {
        en: "Basket type is optional",
        fi: "Korin tyyppi on valinnainen"
    },
    isLockIncluded: {
        en: "Is lock included",
        fi: "Pyöränlukko"
    },
    isLockIncludedToolTip: {
        en: "Lock is optional",
        fi: "Lukko on valinnainen"
    },
    isFrontLightIncluded: {
        en: "Is front light included",
        fi: "Pyörän etuvalo"
    },
    isFrontLightIncludedToolTip: {
        en: "Front light is optional",
        fi: "Etuvalo on valinnainen"
    },
    isRareLightIncluded: {
        en: "Is rare light included",
        fi: "Pyörän takavalo"
    },
    isRareLightIncludedToolTip: {
        en: "Rare light is optional",
        fi: "Takavalo on valinnainen"
    },
    legStandExist: {
        en: "Leg stand exists",
        fi: "Pyöränjalka"
    },
    legStandExistToolTip: {
        en: "Leg stand is optional",
        fi: "Pyöränjalka on valinnainen"
    },
    submit: {
        en: "Submit",
        fi: "Lähetä"
    },
    yes: {
        en: "Yes",
        fi: "Kyllä"
    },
    no: {
        en: "No",
        fi: "Ei"
    },
    notSure: {
        en: "Not sure",
        fi: "En ole varma"
    }
};